type OverlayScheduler = (callback: () => void) => void;

const scheduleAfterDismiss: OverlayScheduler = (callback) => {
  if (
    typeof window !== "undefined" &&
    typeof window.requestAnimationFrame === "function"
  ) {
    window.requestAnimationFrame(() => callback());
    return;
  }

  queueMicrotask(callback);
};

/**
 * Dismiss a transient overlay before opening the surface selected from it.
 *
 * Radix restores focus while popovers and menus close. Waiting until the next
 * frame prevents that focus pass from racing the dialog that replaces them,
 * which is especially noticeable in WebKit.
 */
export function openAfterOverlayDismiss(
  dismiss: () => void,
  open: () => void,
  schedule: OverlayScheduler = scheduleAfterDismiss,
): void {
  dismiss();
  schedule(open);
}
